import { LoggerFactory } from '@ibe/services';

export enum CookieType {
  PERFORMANCE = 'C0002'
}

export default class Cookie {
  private static readonly logger = LoggerFactory.get('Cookie');

  static register(consentChangeCallback: () => void): void {
    if (window.OneTrust) {
      window.OneTrust.OnConsentChanged(() => {
        this.logger.log('Cookie groups: ' + window.OnetrustActiveGroups);

        consentChangeCallback();
      });
    }
  }

  static isEnabled(): boolean {
    return window.OneTrust;
  }

  static hasType(type: CookieType): boolean {
    if (this.isEnabled()) {
      const groups = window.OnetrustActiveGroups.replaceAll(/(^,)|(,$)/g, '').split(',');
      return groups.includes(type);
    }

    return true;
  }
}
